<template>
  <div>
    <div
      class="home-carousel"
      @mouseover="pauseCarousel"
      @mouseout="resumeCarousel"
    >
      <div class="img-carausel">
        <div class="carousel-container">
          <transition-group name="slide" mode="out-in">
            <div :key="currentSlide.id" class="slide">
              <div class="image-wrapper">
                <img :src="currentSlide.image" :alt="currentSlide.alt" />
              </div>
            </div>
          </transition-group>
        </div>
      </div>

      <div class="indicators">
        <span
          v-for="(slide, index) in slides"
          :key="index"
          :class="['indicator-dot', { active: index === currentIndex }]"
          @click="goToSlide(index)"
        ></span>
      </div>
      <div class="btn-right-carousel" @click="slideToRight">
        <i class="fa fa-chevron-right"></i>
      </div>
      <div class="btn-left-carousel" @click="slideToLeft">
        <i class="fa fa-chevron-left"></i>
      </div>
      <!-- Tombol Edit Carousel hanya muncul ketika yang login SIPM -->
      <div class="btn-edit-carousel" v-if="$store.state.role_id == 1">
        <button @click="openEditCarousel">Edit Carousel</button>
      </div>
    </div>
    <div v-if="editCarousel">
      <modal-carousel
        :images="slides"
        @closeModalCarousel="closeEditCarousel"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: ['slides'],
  components: {
    ModalCarousel: () => import('@/components/ModalCarousel.vue'),
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      intervalDuration: 7000,

      modalOpen: false,
      editCarousel: false,
      vendorList: [],
    }
  },

  computed: {
    currentSlide() {
      return this.slides[this.currentIndex]
    },
    previousSlide() {
      if (this.currentIndex === 0) {
        return this.slides[this.slides.length - 1]
      }
      return this.slides[this.currentIndex - 1]
    },
    nextSlide() {
      if (this.currentIndex === this.slides.length - 1) {
        return this.slides[0]
      }
      return this.slides[this.currentIndex + 1]
    },
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopSlideInterval()
  },

  methods: {
    goToSlide(index) {
      this.currentIndex = index
    },
    slideToLeft() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length
    },
    slideToRight() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
    },
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.slideToRight()
      }, this.intervalDuration)
    },
    stopSlideInterval() {
      clearInterval(this.intervalId)
    },

    openEditCarousel() {
      this.editCarousel = true
    },

    closeEditCarousel() {
      this.editCarousel = false
    },

    restartCarousel() {
      this.stopSlideInterval()
      this.startCarousel()
    },

    slideToLeft() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.restartCarousel()
    },

    slideToRight() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.restartCarousel()
    },

    pauseCarousel() {
      this.stopSlideInterval()
    },

    resumeCarousel() {
      this.startCarousel()
    },
  },
}
</script>
